import { useHistory } from 'react-router-dom';

import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

import { Camera } from 'src/models/Camera.model';
import { CameraMode } from 'src/models/CameraMode.model';

const useNavigateAfterConfirm = () => {
  const {
    practiceSettings: { camera },
    cameraData,
    cameraMode,
  } = useRemoteBoundStore();

  const history = useHistory();

  const navigateAfterConfirm = () => {
    if (
      camera === Camera.SMALL &&
      cameraMode === CameraMode.API &&
      cameraData
    ) {
      history.push('/session-hint');
      return;
    }

    history.push('/session-preview');
  };

  return navigateAfterConfirm;
};

export default useNavigateAfterConfirm;
